export default "__VITE_ASSET__BFFGYde2__"